var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarRating = function SvgStarRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_627_58728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3.60396L24.6322 13.5389C24.9202 14.2314 25.5714 14.7045 26.319 14.7645L37.0446 15.6243L28.8728 22.6243C28.3032 23.1122 28.0545 23.8778 28.2285 24.6073L30.7251 35.0737L21.5425 29.465C20.9025 29.074 20.0975 29.074 19.4575 29.465L10.2749 35.0737L12.7715 24.6073C12.9455 23.8778 12.6968 23.1122 12.1272 22.6243L3.95538 15.6243L14.681 14.7645C15.4286 14.7045 16.0798 14.2314 16.3678 13.5389L20.5 3.60396Z",
    stroke: "#C4C3C3",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_627_58728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
export default SvgStarRating;